import React from 'react';
import EmptyState from '../../components/shared/EmptyState';

export class DeetEmpty extends React.Component {
  render () {
    return (
      <div className="col deet-empty mt-4">
        <EmptyState
          icon="info_outline"
          image={ null }
          title={ 'No responses yet.' }
          message={ null }
        />
      </div>
    );
  }
}